import { useState, useEffect } from 'react';
import { teamMemberService } from '../services/apiService';
import TeamMemberList from '../components/TeamMemberList';

const TeamMembers = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchTeamMembers = async () => {
    try {
      setLoading(true);
      const data = await teamMemberService.getAllTeamMembers();
      setTeamMembers(data);
    } catch (err) {
      setError(err.message || 'Failed to fetch team members');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTeamMembers();
  }, []);

  if (loading) {
    return <div className="text-center py-8">Loading team members...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">{error}</div>;
  }

  return (
    <div>
      <h2 className="text-2xl font-medium text-gray-800 mb-6">Team Members Management</h2>
      <TeamMemberList teamMembers={teamMembers} fetchTeamMembers={fetchTeamMembers} />
    </div>
  );
};

export default TeamMembers;